__turbopack_context__.v({
  "flag": "LanguageSwitcher-module-scss-module__8Sf5VW__flag",
  "globalStyles": "LanguageSwitcher-module-scss-module__8Sf5VW__globalStyles",
  "languageSwitcher": "LanguageSwitcher-module-scss-module__8Sf5VW__languageSwitcher",
  "menuItem": "LanguageSwitcher-module-scss-module__8Sf5VW__menuItem",
  "select": "LanguageSwitcher-module-scss-module__8Sf5VW__select",
});
